"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variationPaymentStatusTags = variationPaymentStatusTags;
exports.variationReleaseRequestable = variationReleaseRequestable;
const case_payment_status_helpers_js_1 = require("../case-workflow/case-payment-status.helpers.js");
const paid_off_platform_js_1 = require("../invoice/paid-off-platform.js");
/**
 * Payment-status labels for one variation row.
 * Draft and pending review have no payment state (the section heading already says that).
 * An accepted addition uses the same labels as the milestone table on that flow.
 * An accepted deduction keeps its invoice deduction label.
 */
function variationPaymentStatusTags(input) {
    if (input.bucket !== "accepted")
        return [];
    if (input.kind === "reduction") {
        return input.deductionStatusLabel ? [input.deductionStatusLabel] : [];
    }
    if (input.caseWorkflow) {
        if (!input.invoice)
            return [];
        if ((0, paid_off_platform_js_1.isPaidOffPlatform)(input.invoice))
            return [paid_off_platform_js_1.PAID_OFF_PLATFORM_LABEL];
        const paid = String(input.invoice.status || "").toLowerCase() === "paid";
        if (paid && (input.caseHeld ?? 0) <= 0 && (input.caseReleased ?? 0) > 0) {
            return ["Released from Escrow"];
        }
        return (0, case_payment_status_helpers_js_1.getCasePaymentStatusTags)(input.invoice, {
            paymentRequestStatus: input.fullyReleased ? "approved" : null,
            milestoneAmount: input.amount,
        }).tags;
    }
    if (input.releasePending)
        return ["Under Review"];
    if ((0, paid_off_platform_js_1.isPaidOffPlatform)(input.invoice))
        return [paid_off_platform_js_1.PAID_OFF_PLATFORM_LABEL];
    if (input.fullyReleased)
        return ["Released from Escrow"];
    if (String(input.invoice?.status || "").toLowerCase() === "paid") {
        return [input.fundedStandardLabel || "In Escrow"];
    }
    return ["Unpaid"];
}
/** A release checkbox is only for money still held in escrow. "50% In Escrow" counts. "Released" does not. */
function variationReleaseRequestable(tags) {
    return tags.some((tag) => tag === "In Escrow" || tag.endsWith("In Escrow"));
}
